export const coordEqual = (a, b) => Math.round(a * 1000) === Math.round(b * 1000)
export const coordsEqual = (a, b) => coordEqual(a[0], b[0]) && coordEqual(a[1], b[1])
